export const packageId = 2 as number;
export const packageInfo = 'com.resulta.checka';
export const defaultChannel = 'bhau';
export const brandName = 'BHAU';
export const currencyName = 'Rupee';
export const defaultCurrencySymbol = '₹';
export const phoneValidationConfig = {
  countryCode: '91',
  localLength: 10,
  localPrefixPattern: /^[6-9]/,
  localPrefixDescription: '6, 7, 8 or 9',
  localPhonePattern: /^[6-9]\d{9}$/,
  inputMaxLength: 10,
  allowCountryCodeInput: true,
};
export const disabledPhoneCode = true;
export const apiSendPhoneCode = false;
export const defaultPhoneCode = '91';
export const homePage = 'Index';
export const gameNavigateVersion = 1;

export const invitationApplyVisual = {
  backgroundSource: require('@/assets/imgs/invitation/bindphone.webp'),
  brandMark: {
    presentation: 'overlay-image',
    source: require('@/assets/imgs/home/logo.png'),
  },
} as const;

export const brandAssets = {
  invitationBanner: require('@/assets/imgs/invitation/header.webp'),
  invitationIntroImages: [
    require('@/assets/imgs/invitation/topone.webp'),
    require('@/assets/imgs/invitation/toptwo.webp'),
    require('@/assets/imgs/invitation/content.webp'),
  ],
};
